import React from 'react';
import Link from 'gatsby-link';
import ArrowRightPrimary from '../../../assets/global-logos/arrow/arrow-right-primary.svg';
import styles from './project-pagination.module.css';

const ProjectPagination = ({ title, headline, link }) => {
  return (
    <Link to={`/our-work/${link}`} className={styles.wrapper}>
      <div className={styles.content}>
        <h5 className={styles.title}>{title}</h5>
        <h2 className={styles.headline}>{headline}</h2>
        <div className={styles.arrow}>
          <ArrowRightPrimary />
        </div>
      </div>
    </Link>
  );
};

export default ProjectPagination;



// WEBPACK FOOTER //
// ./src/components/project/project-pagination/index.js